import { mapGetters } from 'vuex'
import {
  donutCriteria,
  rainbowCriteria,
  btmSubmitData,
  bookingChangeCriteria
} from './definition'

export default {
  [donutCriteria] (state, getters) {
    return state.donutCriteria
  },
  [rainbowCriteria] (state, getters) {
    return state.rainbowCriteria
  },
  [btmSubmitData] (state, getters) {
    return state.btmSubmitData
  },
  [bookingChangeCriteria] (state, getters) {
    return state.bookingChangeCriteria
  }
}

export const getters = mapGetters({
  donutCriteria,
  rainbowCriteria,
  btmSubmitData,
  bookingChangeCriteria
})



// WEBPACK FOOTER //
// ./src/components/booking/store/getters.js